import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Row, Col, Input, Button } from 'antd';
@inject('userEmailManagementStore','homeStore')
@observer
class FormModal extends Component {
  formRef = React.createRef();
  handleOk=()=>{
    const { userEmailManagementStore, handleCancel } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      userEmailManagementStore.onAddEmailAction({email: fieldsValue.email})
      handleCancel()
    }).catch(err => {})
  }
  render() {
    const { addModalVisible, handleCancel } = this.props
    return (
      <>
        <Modal
          title="Email"
          closable={false}
          visible={addModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type='primary' onClick={this.handleOk}>Save</Button>,
            <Button key="Cancel" onClick={handleCancel}>Cancel</Button>,
          ]}
        >
          <Form ref={this.formRef} key='addEmail'>
            <Row justify='start' gutter={[10,10]}>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='email' label="Email" labelCol={{span:6}} wrapperCol={{span:16}} rules={[{ required: 'true', message: 'Please enter Email without special characters.', pattern: new RegExp(/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) }]}>
                  <Input maxLength={100} placeholder="Please enter ..." />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
  }
}

export default FormModal;
